import React from 'react'
import { fileExt as fileExtConst, topicForLecturer, topicForStudent } from '../../../../../constants/constants'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../services/web/useWebService'
import * as resultOfConsiderPreviousType from './resultOfConsiderPreviousType'
import checkPermission from '../../../../../utilities/checkPermission'
import useLoading from '../../../../../control/loading/useLoading'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import authenStore from '../../../../../stores/authen/authenStore'
// import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'

import _ from 'lodash'
import { DialogType } from '../../../../../control/dialog/dialog'
import { requestWebServiceTypes } from '../../../../../services/web/types'
import { RoutePath } from '../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import {
    DocumentInfo,
    SynthesisReviewInfo,
    SynthesisReviewRemarkInfo,
} from '../../../../../services/web/types/responseWebServiceTypes'
import path from 'path'
import useProjectHook from '../../../shareLogic/useProjectHook'
import { SynthesisReviewProjectRequestType } from '../../../../../services/web/types/requestWebServiceTypes'
import { ResultOfConsiderPreviousType } from './resultOfConsiderPrevious'

// import { fileExt as fileExtConst, topicForLecturer, topicForStudent } from '../../../../../../constants/constants'
export type UseIssueConsiderationPreviousType = ResultOfConsiderPreviousType

const useResultOfConsiderPrevious = (props: UseIssueConsiderationPreviousType) => {
    const { submittedID, projectID } = props
    // const { callbackSaveComplete } = props
    const manageProjectStore = useManageProjectStore()
    const projectHook = useProjectHook()

    const projectData = manageProjectStore.projectData
    const loadingHook = useLoading()
    const translate = useTranslate()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const [initialValues, setInitialValues] = React.useState<any>({})
    // const defaultRemarkRef = React.useRef<string>()
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const profileStore = authenStore()
    const { profile } = profileStore
    const dialogRef = React.useRef<Record<string, Function>>()
    const history = useHistory()
    const [initialComment, setInitialComment] = React.useState<any>()
    const [synthesisReviewInfoList, setSynthesisReviewInfo] = React.useState<SynthesisReviewInfo[]>([])
    const [isLoadedSynthesisReview, setIsLoadedSynthesisReview] = React.useState<boolean>(false)
    const [synthesisReviewRemarkInfoList, setSynthesisReviewRemarkInfo] = React.useState<SynthesisReviewRemarkInfo>()
    const [documentInfoList, setDocumentInfo] = React.useState<DocumentInfo[]>([])
    const [approveStatus, setApproveStatus] = React.useState<resultOfConsiderPreviousType.ApproveType>()
    const [initialRichTextEditor, setInitialRichTextEditor] = React.useState<any>()
    const [initialRichRemark, setInitialRichRemark] = React.useState<any>()

    React.useEffect(() => {
        getSynthesisReviewData()
        getSynthesisData()
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null])

    React.useEffect(() => {
        createInitialData()
        createInitialComment()
        createInitialRichTextEditor()
        createInitialRichRemark()
    }, [isLoadedSynthesisReview])

    React.useEffect(() => {
        createInitialComment()
    }, [translate.languageStore.currentLanguage])

    // const handleClickCancel = (dirty: boolean) => {
    //     if (dirty) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.WARNING'),
    //             content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
    //             type: 'alert-confirm',
    //             onClickConfirm: () => {
    //                 history.push(RoutePath.manageProject)
    //             },
    //         })
    //         dialogRef.current?.openDialog()
    //     } else {
    //         history.push(RoutePath.manageProject)
    //     }
    // }

    const getSynthesisData = async () => {
        // if (projectData?.submittedID) {
        //     loadingHook.loadingOpen()
        //     const submittedID = projectData.submittedID
        //     const { result } = await callWebService.getSynthesisProjectByID(submittedID)
        //     loadingHook.loadingClose()

        //     if (result) {
        //         const approveStatus = {
        //             id: result.approveStatusID,
        //             nameTH: result.approveStatusName_th,
        //             nameEN: result.approveStatusName_en,
        //         }
        //         setApproveStatus(approveStatus)
        //     }
        // }

        if (submittedID) {
            loadingHook.loadingOpen()
            // const submittedID = projectData.submittedID
            const { result } = await callWebService.getSynthesisProjectByID(submittedID)
            loadingHook.loadingClose()

            if (result) {
                const approveStatus = {
                    id: result.approveStatusID,
                    nameTH: result.approveStatusName_th,
                    nameEN: result.approveStatusName_en,
                }
                setApproveStatus(approveStatus)
            }
        }
    }

    const getSynthesisReviewData = async () => {
        // if (projectData?.submittedID) {
        //     setIsLoadedSynthesisReview(false)
        //     loadingHook.loadingOpen()
        //     const submittedID = projectData.submittedID
        //     const data = await callWebService.getSynthesisReview(submittedID)
        //     loadingHook.loadingClose()
        //     if (data.status === 1) {
        //         let documentInfo = [...data.result.documentInfo]
        //         documentInfo.forEach((itm) => {
        //             const topicID = itm.topicID
        //             let isCheckAll: boolean | null = null
        //             itm.fileInfo.forEach((file) => {
        //                 file.topicID = topicID
        //                 if (path.extname(`${file.filename}`) === fileExtConst.pdf) {
        //                     if (file.isStamp && isCheckAll !== false) {
        //                         isCheckAll = true
        //                     } else {
        //                         isCheckAll = false
        //                     }
        //                 }
        //             })
        //             itm.isCheckAll = isCheckAll
        //         })
        //         //  BUG IS STAMP ออกมาเป็น false หมดเลย
        //         // setApproveStatus(data?.result?.approveStatusName_th)
        //         // setDocumentInfo(data.result.documentInfo)

        //         filterTopicUpload(documentInfo)
        //         // setDocumentInfo(documentInfo)
        //         setSynthesisReviewInfo(data.result.synthesisReviewInfo)
        //         setSynthesisReviewRemarkInfo(data.result.synthesisReviewRemarkInfo)
        //         setIsLoadedSynthesisReview(true)
        //     }
        // }

        if (submittedID) {
            setIsLoadedSynthesisReview(false)
            loadingHook.loadingOpen()
            // const submittedID = submittedID
            const data = await callWebService.getSynthesisReview(submittedID)
            loadingHook.loadingClose()
            if (data.status === 1) {
                let documentInfo = [...data.result.documentInfo]
                documentInfo.forEach((itm) => {
                    const topicID = itm.topicID
                    let isCheckAll: boolean | null = null
                    itm.fileInfo.forEach((file) => {
                        file.topicID = topicID
                        if (path.extname(`${file.filename}`) === fileExtConst.pdf) {
                            if (file.isStamp && isCheckAll !== false) {
                                isCheckAll = true
                            } else {
                                isCheckAll = false
                            }
                        }
                    })
                    itm.isCheckAll = isCheckAll
                })
                //  BUG IS STAMP ออกมาเป็น false หมดเลย
                // setApproveStatus(data?.result?.approveStatusName_th)
                // setDocumentInfo(data.result.documentInfo)

                filterTopicUpload(documentInfo)
                // setDocumentInfo(documentInfo)
                setSynthesisReviewInfo(data.result.synthesisReviewInfo)
                setSynthesisReviewRemarkInfo(data.result.synthesisReviewRemarkInfo)
                setIsLoadedSynthesisReview(true)
            }
        }
    }

    const filterTopicUpload = (documentTopic: DocumentInfo[]) => {
        let docTopic: DocumentInfo[] = []
        const researcherTypeID = projectData?.researcherTypeInfo.value
        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, topicNo: index + 1 }
                })
            }
            setDocumentInfo(docTopic)
        }
    }

    const createInitialComment = () => {
        const commentInit = synthesisReviewInfoList?.map((itm: any, idx: number) => {
            return {
                topic:
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? itm.topicName_th
                        : itm.topicName_en,
                id: itm.topicID,
                no: itm.topicNo,
                commentList: itm.synthesisComment,
            }
        })
        setInitialComment(commentInit)
    }

    const createInitialData = () => {
        const { childSelectedList, parentSelectedList } = getInitialChildSelected()

        const initialData = {
            documentCertificate: {
                childSelected: childSelectedList,
                parentSelected: parentSelectedList,
            },
            commentRemarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList.synthesisRemark
                    ? synthesisReviewRemarkInfoList.synthesisRemark
                    : null,
            remarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    : '-',
        }

        setInitialValues(initialData)
    }

    const getInitialChildSelected = () => {
        let childSelectedList: any = []
        let parentSelectedList: any = []

        documentInfoList.forEach((documentItm) => {
            if (documentItm.fileInfo.length > 0) {
                documentItm.fileInfo.forEach((file) => {
                    if (file.isStamp) {
                        childSelectedList.push(file)
                    }
                })
            }
            if (documentItm.isCheckAll) {
                parentSelectedList.push(documentItm)
            }
        })

        return { parentSelectedList, childSelectedList }
    }

    const createInitialRichTextEditor = () => {
        const initialData = synthesisReviewInfoList.map((itm) => {
            return {
                contentHtml: itm.synthesisReviewCommentHtmlTag
                    ? itm.synthesisReviewCommentHtmlTag
                    : itm.synthesisComment,
                contentText: itm.synthesisReviewComment,
            }
        })

        setInitialRichTextEditor(initialData)
    }

    const createInitialRichRemark = () => {
        const initialData = {
            contentHtml: isViewMode
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    : '-'
                : synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                : synthesisReviewRemarkInfoList?.synthesisRemark,
            contentText: synthesisReviewRemarkInfoList?.synthesisReviewRemark,
        }

        setInitialRichRemark(initialData)
    }

    return {
        approveStatus,
        initialValues,
        projectData,
        initialComment,
        documentInfoList,
        initialRichTextEditor,
        initialRichRemark,
        isViewMode,
        isFlowApproveWithComment: projectData ? projectHook.isFlowApproveWithComment(projectData) : false,
        // onClickCancel: handleClickCancel,
    }
}

export default useResultOfConsiderPrevious
